
import { Component, Prop, Vue} from "vue-property-decorator";
import timeRangeForNew from "@/helpers/cardInfoHelperFunctions/timeRangeForNew";

import GET_DOCUMENTS from "@/apollo/dashboard/GetDocuments.gql";

import DashboardCardScaffold from "@/components/dashboard/cards/CardScaffoldDocuments.vue";
import CardItemScaffold from "@/components/dashboard/cards/CardItemScaffoldDocuments.vue";
import DocumentIcon from "@/components/icons/DocumentIcon.vue";
import UploadDocument from "@/components/documents/UploadDocument.vue";
import DocumentExtensionIcon from "@/components/documents/DocumentExtensionIcon.vue";
import RouteNames from "@/entities/RouteNames";
import RouteParams from "@/entities/RouteParams";

import Roles from "@/entities/Roles";
import { User } from "@/generated/graphql";


@Component({
  components: {
    DashboardCardScaffold,
    CardItemScaffold,
    DocumentIcon,
    UploadDocument,
    DocumentExtensionIcon,
  },
  apollo: {
    documents: {
      query: GET_DOCUMENTS,
      variables() {
        return this.filters
      },
      update(data) {
        return data;
      }
    }
  }
})
export default class DashboardDocuments extends Vue {
  @Prop({type: String, required: true}) readonly companyId!: string;
  @Prop({type: String, required: true}) readonly currentUserId!: string;
  @Prop({type: Boolean, default: false}) readonly isAdmin!: boolean;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;


  routes = RouteNames;
  documents: any = null;

  get filters(): object {
    return {
      newDocumentFilter: {
        _and: [
          {created_at: {_gt: timeRangeForNew(this.$moment)}},
          {uploaded_by: { _eq: this.currentUserId}}
        ]
      },
      
      documentFilter: {
        uploaded_by: { _eq: this.currentUserId}
      },
      documentTotalFilter: {
        company_id: { _eq: this.companyId}
      },

      // projectsFilter: {
        
      // }
      contractorDocumentsFilter:{
        company_id: {_eq: this.companyId}, _and: {attached_to: {user:{role:{_eq: Roles.CONTRACTOR}}}}
      },
      projectDocumentsFilter:{company_id: {_eq: this.companyId}, _and: {document_projects: {}}}
    }
  }

  get newDocuments(): any[] {
    if (!this.documents) {
      return [];
    }
    return this.documents.newDocuments;
  }

  get allDocuments(): any[] {
    if (!this.documents) {
      return [];
    }
    return this.documents.documents;
  }

  // get newDocumentsTotal(): number | undefined {
  //   if (!this.documents) {
  //     return undefined;
  //   }
  //   return this.documents.newDocumentsTotal.aggregate.count;
  // }

  get allDocumentsTotal(): number | undefined {
    if (!this.documents) {
      return undefined;
    }
    return this.documents.documentsTotal.aggregate.count;
  }

  get contractorDocumentsTotal(): number | undefined {
    if (!this.documents) {
      return undefined;
    }
    return this.documents.contractorDocumentsTotal.aggregate.count;
  }

  get projectDocumentsTotal(): number | undefined {
    if (!this.documents) {
      return undefined;
    }
    return this.documents.projectDocumentsTotal.aggregate.count;
  }

  refetchDocuments(): void {
    this.$apollo.queries.documents.refetch();
  }

  get redirectTo(): string | undefined {
    if (!this.isAdmin) {
      return RouteNames.DOCUMENTS_MANAGER_ALL;
    }
    return RouteNames.DOCUMENTS_ADMIN_ALL;
  }

  get redirectToProject(): string | undefined {
    if (!this.isAdmin) {
      return RouteNames.DOCUMENTS_MANAGER_PROJECTS;
    }
    return RouteNames.DOCUMENTS_ADMIN_PROJECTS;
  }

  get redirectToContractor(): string | undefined {
    if (!this.isAdmin) {
      return RouteNames.DOCUMENTS_MANAGER_CONTRACTORS;
    }
    return RouteNames.DOCUMENTS_ADMIN_CONTRACTORS;
  }
}
